<template>
  <div>
    <div class="BkHash">
      <div class="BkHash-W">
        <div class="BkHash-Inp"><Homseach></Homseach></div>
        <div class="BkHash_conent">
          <div class="BkHash_conent_header">
            <p>
              <span>Transaction Details</span>
            </p>
          </div>
          <div class="BkHash_conent_Ul">
            <ul>
              <li>
                <p>{{ list[0].Total }}</p>
                <p>
                  <span
                    @click="blockHeight(list[0].Balance)"
                    class="notranslate"
                    >{{ list[0].Balance }}</span
                  >
                </p>
              </li>
              <li>
                <p>{{ list[1].Total }}</p>
                <p class="notranslate">
                  <span>{{ list[1].Balance }}</span>
                </p>
              </li>
              <li>
                <p>{{ list[2].Total }}</p>
                <p>
                  <span class="notranslate" ref="ele">{{
                    list[2].Balance
                  }}</span>
                  <img
                    style="width: 24px; height: 24px; margin-top: 22px"
                    :src="list[2].ImgUrl"
                    v-clipboard:copy="copyContent"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                    @click="Fuz"
                  />
                </p>
              </li>
              <li>
                <p>{{ list[3].Total }}</p>
                <p>
                  <span class="notranslate" @click="form"
                    >{{ list[4].Balance }} <span>( {{ TimeDate }} )</span>
                  </span>
                </p>
              </li>
              <li>
                <p>{{ list[4].Total }}</p>
                <p>
                  <span>{{ list[5].Balance }} TTOS</span>
                </p>
              </li>
              <!-- <li>
                <p>{{ list[5].Total }}</p>
                <p>
                  <el-collapse v-model="activeNames" @change="handleChange">
                    <el-collapse-item
                      :title="signList.length + ' signers (See all)'"
                      name="1"
                    >
                      <span class="listbox">
                        <div
                          class="listboxli"
                          v-for="(item, index) in signList"
                          :key="index"
                        >
                          <span @click="address(index)">{{ item }}</span>
                        </div>
                      </span>
                    </el-collapse-item>
                  </el-collapse>
                </p>
              </li> -->
            </ul>
          </div>
        </div>
        <!-- 普通交易开始 -->

        <div
          class="overmore"
          v-if="
            type == 1 ||
            type == 2 ||
            type == 3 ||
            type == 4 ||
            type == 5 ||
            type == 'to' ||
            type == 'from' ||
            type == -1
          "
        >
          <div class="overmore_tit">Overview</div>
          <div class="overmore_con">
            <div class="overmore_li">
              <div class="overmore-lil">Transaction Type :</div>
              <div class="overmore-lir">{{ typename }}</div>
            </div>
            <div class="overmore_li" v-if="typename !== 'Bonus'">
              <div class="overmore-lil">From :</div>
              <div class="overmore-lir block" v-if="fromAddress !== 'Unstake'">
                <span @click="to2(fromAddress)">{{ fromAddress }}</span>
                <img
                  :src="list[2].ImgUrl"
                  v-clipboard:copy="fromAddress"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                  style="width: 24px; height: 24px; border-radius: 50%"
                />
              </div>
              <div style="color: #898b8d; font-size: 14px" v-else>
                <span>{{ fromAddress }}</span>
              </div>
            </div>
            <div class="overmore_li" v-if="typename == 'Bonus'">
              <div class="overmore-lil">From :</div>
              <div class="overmore-lir">
                <span>Bonus</span>
              </div>
            </div>
            <div
              class="overmore_li"
              v-if="toAddressa.length == 0 && typename !== 'Genesis'"
            >
              <div class="overmore-lil">To :</div>
              <div class="overmore-lir">
                <div class="overmore_adressbox">
                  <div v-if="toAddressb != 'Stake'">
                    <span @click="to2(toAddressb)">{{ toAddressb }}</span>
                    <img
                      :src="list[2].ImgUrl"
                      v-clipboard:copy="toAddressb"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                      style="width: 24px; height: 24px; margin-left: 2px"
                    />
                  </div>
                  <div v-else style="color: #898b8d">{{ toAddressb }}</div>
                </div>
              </div>
            </div>
            <!-- <div
              class="overmore_li"
            v-else
             
            >
              <div class="overmore-lil">To :</div>
              <div class="overmore-lir">
                <div class="overmore_adressbox">
                  <div  style="color: #898b8d;padding-top: 0px;">
                    Stake
                  </div>
                </div>
              </div>
            </div> -->
            <div class="overmore_li" v-if="toAddressaa.length >= 5">
              <div class="overmore-lil">To :</div>
              <div class="overmore-lir">
                <div class="overmore_adressbox">
                  <div
                    v-for="(item, index) in toAddressaa.slice(0, 5)"
                    :key="index"
                  >
                    <span @click="to2(item.address)">{{ item.address }}</span
                    ><img
                      src="../../../assets/pc/Index/fz.png"
                      v-clipboard:copy="item.address"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                    />
                    <!-- <span
                      >{{ Number(item.amount).toLocaleString() }}TTOS</span
                    > -->
                    <span
                      >{{
                        new Intl.NumberFormat("en-US", {
                          minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                          maximumFractionDigits: 20,
                        }).format(item.amount)
                      }}
                      TTOS</span
                    >
                  </div>

                  <!-- v-if="toAddress.length>=5" -->
                  <div class="more" v-if="toAddressaa.length >= 5">
                    <el-button type="text" @click="dialogVisible = true"
                      >More</el-button
                    >
                  </div>
                </div>
              </div>
            </div>
            <div
              class="overmore_li"
              v-if="toAddressaa.length < 5 && toAddressaa.length >= 1"
            >
              <div class="overmore-lil">To :</div>
              <div class="overmore-lir">
                <div class="overmore_adressbox">
                  <div
                    v-for="(item, index) in toAddressaa.slice(0, 5)"
                    :key="index"
                  >
                    <span @click="to2(item.address)">{{ item.address }}</span>
                    <img
                      src="../../../assets/pc/Index/fz.png"
                      v-clipboard:copy="item.address"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="overmore_li" v-if="typename !== 'Genesis'">
              <div class="overmore-lil">Amount :</div>
              <div class="overmore-lir">
                <!-- {{ Number(amount).toLocaleString() }}TTOS -->
                {{
                  new Intl.NumberFormat("en-US", {
                    minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                    maximumFractionDigits: 10,
                  }).format(amount)
                }}
                TTOS
              </div>
            </div>
            <el-dialog
              title=""
              :visible.sync="dialogVisible"
              width="520px!important;"
              :modal="true"
              :before-close="handleClose"
            >
              <div class="tangkuang">
                <div class="tangkuang_tit">
                  <div>Address</div>
                  <div>Amount</div>
                </div>
                <div class="tangkuang_con">
                  <div
                    class="tangkuang_li"
                    v-for="(item, index) in toAddressa"
                    :key="index"
                  >
                    <span @click="to2(item.address)" style="cursor: pointer">{{
                      item.address
                    }}</span
                    ><img
                      src="@/assets/pc/Index/fz.png"
                      v-clipboard:copy="item.address"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                    />
                    <!-- <span
                      >{{ Number(item.amount).toLocaleString() }} TTOS</span
                    > -->
                    <span
                      >{{
                        new Intl.NumberFormat("en-US", {
                          minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                          maximumFractionDigits: 20,
                        }).format(item.amount)
                      }}
                      TTOS</span
                    >
                  </div>
                </div>
                <div class="Block_List_Bottom" style="margin-top: 10px">
                  <el-pagination
                    ref="Pagination"
                    :current-page.sync="PaginationIndex"
                    background
                    small
                    :page-size="5"
                    layout="prev, pager,
      next"
                    @current-change="CurrentChange"
                    :total="total1s"
                  >
                  </el-pagination>
                </div>
              </div>
            </el-dialog>
          </div>
        </div>
        <!-- 普通交易结束 -->
        <!-- 申领交易开始 -->
        <div
          v-if="
            type == 99 ||
            type == 'toAward' ||
            type == 'commission' ||
            type == 'fromAward'
          "
          :class="toAwardList.length > 3 ? 'Overview mianaa' : 'Overview miana'"
        >
          <div class="overview_title">Overview</div>
          <div class="overview_content">
            <div class="overview_left">
              <div>Validator :</div>
              <div>Bonus era :</div>
              <div>Amount :</div>
              <div>Commission :</div>
              <div>Bonus :</div>
            </div>
            <div class="overview_right">
              <div
                style="color: #fff; cursor: pointer"
                @click="to2(toAwardList[0].fromAddress)"
              >
                <img :src="validatorLogo" style="border-radius: 50%" />
                {{ validatorNickName }}
              </div>
              <div>{{ TimeDatea }} 00:00:00-{{ TimeDatea }} 24:00:00</div>
              <div>
                {{
                  new Intl.NumberFormat("en-US", {
                    minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                    maximumFractionDigits: 20,
                  }).format(amount)
                }}
                TTOS
              </div>
              <div>{{ Commission }} TTOS</div>
              <div
                class="overview_flex"
                v-for="(item, index) in toAwardList.slice(0, 5)"
                :key="index"
              >
                <div
                  class="overview_flexl"
                  style="cursor: pointer"
                  @click="to2(item.address)"
                >
                  {{ item.address }}
                </div>
                <div class="overview_flexr">
                  {{ parseFloat(item.amount).toFixed(8) }} TTOS({{
                    ((item.amount / percentages) * 100).toFixed(2)
                  }}%)
                </div>
              </div>
              <div
                v-if="toAwardList.length >= 5"
                style="color: #fff; cursor: pointer"
                @click="dialogVisible3 = true"
              >
                More
              </div>
            </div>
          </div>
          <el-dialog
            title=""
            :visible.sync="dialogVisible3"
            width="520px!important;"
            :modal="true"
            :before-close="handleClose"
          >
            <div class="tangkuang">
              <div class="tangkuang_tit" style="height: 24px">
                <div>Address</div>
                <div>Amount</div>
              </div>
              <div class="tangkuang_con">
                <div
                  class="tangkuang_li"
                  v-for="(item, index) in toAwardList"
                  :key="index"
                >
                  <span @click="to2(item.address)" style="cursor: pointer">{{
                    item.address
                  }}</span
                  ><img
                    src="@/assets/pc/Index/fz.png"
                    v-clipboard:copy="item.address"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                  /><span>
                    {{ parseFloat(item.amount).toFixed(8) }} TTOS({{
                      ((item.amount / percentages) * 100).toFixed(2)
                    }}%)</span
                  >
                </div>
              </div>
              <!-- <div class="Block_List_Bottom" style="margin-top: 10px;" v-if="toAwardList.length >= 5">
                  <el-pagination
                    ref="Pagination"
                    :current-page.sync="PaginationIndex"
                    background
                    small
                    :page-size="5"
                    layout="prev, pager,
      next"
                    @current-change="CurrentChange"
                    :total="total1s"
                  >
                  </el-pagination>
                </div> -->
            </div>
          </el-dialog>
        </div>
        <!-- 申领交易结束 -->
        <!-- TFSC交易详情结束 -->
        <!-- <div class="Overview mianb" v-if="(type == 7 && standard=='ERC-20') || (type==8&& standard=='ERC-20')"> -->
        <div class="Overview mianb" v-if="type == 7">
          <div class="overview_title">Overview</div>
          <div class="overview_content">
            <div class="overview_left">
              <div>Transaction Type :</div>
              <div>Contract Creator :</div>
              <div>Contract Address :</div>
              <div>Contract Name :</div>
            </div>
            <div class="overview_right">
              <div>Contract Creation</div>
              <div style="color: #fff; cursor: pointer">
                <span @click="to2(contractCreator)">{{ contractCreator }}</span>
                <img
                  :src="list[2].ImgUrl"
                  v-clipboard:copy="contractCreator"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                />
              </div>
              <div class="contract">
                <el-tooltip placement="top" popper-class="toolTipClass">
                  <div slot="content">Smart contract account</div>
                  <img src="../../../assets/pc/Index/verview.png" />
                </el-tooltip>
                <div
                  class="hash"
                  @click="cHash2(contractAddress)"
                  v-if="type == 7 && standard == 'ERC-721'"
                >
                  {{ contractAddress }}
                </div>
                <div
                  class="hash"
                  @click="Address(contractAddress)"
                  v-if="type == 7 && standard == 'ERC-20'"
                >
                  {{ contractAddress }}
                </div>
                <img
                  :src="list[2].ImgUrl"
                  v-clipboard:copy="contractAddress"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                />
              </div>

              <div>{{ contractName }}</div>
            </div>
          </div>
        </div>

        <!-- TFSc交易详情结束 -->
        <!-- NFT转账开始 -->
        <div class="Overview mianb" v-if="type == 8 && standard == 'ERC-20'">
          <div class="overview_title">Overview</div>
          <div class="overview_content">
            <div class="overview_left">
              <div>Transaction Type :</div>
              <div>From :</div>
              <div>Interacted WIth (To) :</div>
              <div>Tokens Transferred :</div>
              <div>Reward :</div>
            </div>
            <div class="overview_right">
              <div>{{ functions }}</div>
              <div style="color: #fff; cursor: pointer">
                <span @click="to2(fromAddress)"> {{ fromAddress }}</span>
                <img
                  :src="list[2].ImgUrl"
                  v-clipboard:copy="fromAddress"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                />
              </div>
              <div class="contract">
                <div @click="Block(contractAddress)" style="cursor: pointer">
                  Contract
                </div>
                <el-tooltip placement="top" popper-class="toolTipClass">
                  <div slot="content">Smart contract account</div>
                  <img src="../../../assets/pc/Index/verview.png" />
                </el-tooltip>
                <div
                  class="hash"
                  style="cursor: pointer"
                  @click="Block(contractAddress)"
                >
                  {{ contractAddress }}
                </div>
                <img
                  :src="list[2].ImgUrl"
                  v-clipboard:copy="contractAddress"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                />
              </div>
              <div class="contract">
                <div style="cursor: pointer">
                  <span>From</span
                  ><span @click="from2(fromAddress)" style="color: #fff">{{
                    fromAddress1
                  }}</span
                  ><img
                    :src="list[2].ImgUrl"
                    v-clipboard:copy="fromAddress"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                  />
                </div>
                <!-- <el-tooltip placement="top" popper-class="toolTipClass">
                  <div slot="content">Smart contract account</div>
                  <img src="../../../assets/pc/Index/verview.png" />
                </el-tooltip> -->
                <div
                  class="hash"
                  v-if="toAddress == ''"
                  style="cursor: pointer"
                  @click="from2(toAddress)"
                >
                  <span>To</span>{{ toAddress1 }}
                </div>
                <div
                  style="cursor: pointer"
                  @click="from2(toAddress)"
                  v-if="toAddress1 !== ''"
                >
                  <span>To</span>{{ toAddress1 }}
                </div>
                <img
                  v-if="toAddress1 !== ''"
                  :src="list[2].ImgUrl"
                  v-clipboard:copy="toAddress"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                />
                <!-- <img
                  v-else
                  :src="list[2].ImgUrl"
                  v-clipboard:copy="toAddress"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                /> -->
                <div style="cursor: pointer" @click="Address(contractAddress)">
                  <!-- <span> {{ Number(tokenAmount).toLocaleString() }}</span> -->
                  <span v-if="tokenAmount !==null">
                    <span v-if="tokenAmount > 999">
                      {{
                        new Intl.NumberFormat("en-US", {
                          minimumFractionDigits: 8, // 设置为足够大的值以保留所有小数位
                          maximumFractionDigits: 30,
                        }).format(tokenAmount)
                      }}
                      <!-- aaa  {{
                        Number(tokenAmount).toLocaleString()
                      }} -->
                    </span>

                    <span v-else>{{ tokenAmount }}</span>
                  </span>
                  <span v-else>{{
                    new Intl.NumberFormat("en-US", {
                      minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                      maximumFractionDigits: 10,
                    }).format(tokenAmount)
                  }}</span>
                  <img
                    :src="logo"
                    style="width: 28px; height: 28px; border-radius: 50%"
                  />
                  {{ symbol }}
                </div>
              </div>
              <div>{{ contractTip }}TTOS</div>
            </div>
          </div>
        </div>
        <!-- NFT转账结束 -->
        <div class="BkHash_conentb" v-if="type == 8 && standard == 'ERC-721'">
          <div class="BkHash_conent_header">
            <p>
              <span>Overview:</span>
            </p>
          </div>
          <div class="BkHash_conent_Ul">
            <ul>
              <li>
                <p>Transaction Type :</p>
                <p>
                  <span class="notranslate" style="color: #898b8d">{{
                    functions
                  }}</span>
                </p>
              </li>
              <li>
                <p>From :</p>
                <p class="notranslate" style="color: #fff; cursor: pointer">
                  <span @click="to2(fromAddress)">{{ fromAddress }}</span
                  ><img
                    :src="list[2].ImgUrl"
                    v-clipboard:copy="fromAddress"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                  />
                </p>
              </li>

              <li>
                <p>Interacted WIth (To) :</p>
                <p style="color: #fff; cursor: pointer">
                  <span
                    @click="cHash2(contractAddress)"
                    style="margin-right: 16px"
                    >Contract</span
                  >
                  <el-tooltip placement="top" popper-class="toolTipClass">
                    <span slot="content">Smart contract account</span>
                    <img
                      src="../../../assets/pc/Index/verview.png"
                      style="
                        width: 14px !important;
                        height: 17px;
                        margin-top: 12px;
                        cursor: pointer;
                      "
                    />
                  </el-tooltip>
                  <span
                    class="hash"
                    @click="cHash2(contractAddress)"
                    style="margin-left: 12px"
                  >
                    {{ contractAddress }}
                  </span>
                  <img
                    :src="list[2].ImgUrl"
                    v-clipboard:copy="contractAddress"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                  />
                </p>
              </li>

              <li v-if="tokenAmountlist.length > 5">
                <p>Tokens Transferred :</p>
                <p>
                  <el-collapse v-model="activeName">
                    <el-collapse-item :name="1" class="activnams">
                      <span class="listbox">
                        <div
                          style="margin: 0px; padding: 0px; line-height: 30px"
                          v-for="(item, index) in tokenAmountlista.slice(0, 5)"
                          :key="index"
                        >
                          <span style="color: #898b8d">
                            From
                            <span class="black" @click="from2(fromAddress)">{{
                              fromAddress1
                            }}</span></span
                          ><img
                            :src="list[2].ImgUrl"
                            v-clipboard:copy="fromAddress"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onError"
                          />
                          <span>
                            To
                            <span class="black" @click="to2(toAddress)">{{
                              toAddress1
                            }}</span></span
                          ><img
                            :src="list[2].ImgUrl"
                            v-clipboard:copy="toAddress"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onError"
                          />
                          <img
                            v-if="nftImageLists.length > 1"
                            :src="nftImageLists[index]"
                            style="
                              border-radius: 4px;
                              width: 20px;
                              height: 20px;
                              margin-top: 4px;
                              margin-bottom: 2px;
                              cursor: pointer;
                            "
                            @click="cHash(item)"
                          />
                          <img
                            v-else
                            :src="logo"
                            style="
                              border-radius: 4px;
                              width: 18px;
                              height: 18px;
                            "
                            @click="cHash(item)"
                          />
                          <span @click="cHash(item)">
                            TokenID
                            <span class="black"
                              >({{ item.split("#")[1] }})</span
                            ></span
                          >
                          <img
                            :src="logo1"
                            style="
                              border-radius: 50%;
                              width: 18px;
                              height: 18px;
                              margin-top: 6px;
                            "
                            @click="cHash2(item)"
                          />
                          <span @click="cHash2(item)" class="black">{{
                            contractName
                          }}</span>
                        </div>
                      </span>
                    </el-collapse-item>
                  </el-collapse>
                </p>
              </li>
              <li
                v-if="
                  tokenAmountlist.length <= 5 &&
                  toAddress !== null &&
                  tokenAmount !== null
                "
              >
                <p>Tokens Transferred:</p>
                <p>
                  <el-collapse v-model="activeName">
                    <el-collapse-item :name="1" class="activnams">
                      <span class="listbox">
                        <div
                          style="margin: 0px; padding: 0px"
                          v-for="(item, index) in tokenAmountlista"
                          :key="index"
                        >
                          <span style="color: #898b8d">
                            From
                            <span class="black" @click="from2(fromAddress)">{{
                              fromAddress1
                            }}</span></span
                          ><img
                            :src="list[2].ImgUrl"
                            v-clipboard:copy="fromAddress"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onError"
                            style="cursor: pointer"
                          />
                          <span>
                            To
                            <span class="black" @click="to2(toAddress)">{{
                              toAddress1
                            }}</span></span
                          ><img
                            :src="list[2].ImgUrl"
                            v-clipboard:copy="toAddress"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onError"
                            style="cursor: pointer"
                          />
                          <img
                            v-if="nftImageLists.length > 1"
                            :src="nftImageLists[index]"
                            style="
                              border-radius: 4px;
                              width: 24px;
                              height: 24px;
                              cursor: pointer;
                            "
                            @click="cHash(item)"
                          />

                          <img
                            v-else
                            :src="logo"
                            style="
                              border-radius: 4px;

                              height: 24px;
                              cursor: pointer;
                            "
                            @click="cHash(item)"
                          />
                          <span @click="cHash(item)">
                            TokenID
                            <span class="black"
                              >({{ item.split("#")[1] }})</span
                            ></span
                          >
                          <img
                            :src="logo1"
                            style="
                              border-radius: 50%;
                              width: 18px;
                              height: 18px;
                              cursor: pointer;
                              margin-top: 2px;
                            "
                            @click="cHash2(item)"
                          />

                          <span @click="cHash2(item)" class="black">{{
                            contractName
                          }}</span>
                        </div>
                      </span>
                    </el-collapse-item>
                  </el-collapse>
                </p>
              </li>
              <li v-if="tokenAmountlist.length > 5">
                <p></p>
                <p
                  style="color: #fff; cursor: pointer"
                  @click="dialogVisible1 = true"
                >
                  More
                </p>
              </li>
              <li>
                <p>Reward :</p>
                <p style="color: #898b8d">
                  <!-- <span> {{ Number(contractTip).toLocaleString() }} TTOS</span> -->
                  <span
                    >{{
                      new Intl.NumberFormat("en-US", {
                        minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                        maximumFractionDigits: 20,
                      }).format(contractTip)
                    }}
                    TTOS</span
                  >
                </p>
              </li>
              <li v-if="functions == 'mint'">
                <p>Price :</p>
                <p style="color: #898b8d">
                  <span
                    >{{
                      new Intl.NumberFormat("en-US", {
                        minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                        maximumFractionDigits: 20,
                      }).format(contractTransfer)
                    }}
                    TTOS</span
                  >
                  <!-- <span>
                    {{ Number(contractTransfer).toLocaleString() }}TTOS</span
                  > -->
                </p>
              </li>
              <el-dialog
                title=""
                :visible.sync="dialogVisible1"
                width="520px !important"
                height="500px !important"
                :modal="true"
                :before-close="handleClose"
              >
                <span
                  class="listbox"
                  style="
                    display: block;
                    height: 300px;
                    overflow: hidden;
                    margin-left: 14px;

                    scrollbar-width: none !important; /* firefox */
                    -ms-overflow-style: none !important; /* IE 10+ */
                    background-color: #000;
                  "
                >
                  <div
                    style="
                      margin: 0px;
                      padding: 0px;
                      height: 30px;
                      line-height: 30px;
                    "
                    v-for="(item, index) in tokenAmountlist"
                    :key="index"
                  >
                    <span style="color: #898b8d">
                      From
                      <span
                        style="color: #fff; cursor: pointer"
                        @click="from2(fromAddress)"
                        >{{ fromAddress1 }}</span
                      ></span
                    ><img
                      :src="list[2].ImgUrl"
                      v-clipboard:copy="fromAddress"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                      style="width: 18px; height: 18px"
                    />
                    <span>
                      To
                      <span
                        style="color: #fff; cursor: pointer"
                        @click="to2(toAddress)"
                        >{{ toAddress1 }}</span
                      ></span
                    ><img
                      :src="list[2].ImgUrl"
                      v-clipboard:copy="toAddress"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                      style="width: 18px; height: 18px"
                    />

                    <img
                      v-if="nftImageLists.length > 1"
                      :src="nftImageLists[index * PaginationIndex]"
                      style="
                        border-radius: 4px;
                        width: 18px;
                        height: 18px;
                        margin: 6px 6px 0px 6px;
                        cursor: pointer;
                      "
                      @click="cHash(item)"
                    />
                    <img
                      v-else
                      :src="logo"
                      style="
                        border-radius: 4px;
                        width: 18px;
                        height: 18px;
                        margin: 6px 6px 0px 6px;
                        cursor: pointer;
                      "
                      @click="cHash(item)"
                    />
                    <span @click="cHash(item)">
                      TokenID
                      <span style="color: #fff; cursor: pointer"
                        >({{ item.split("#")[1] }})</span
                      ></span
                    >
                    <img
                      :src="logo1"
                      style="
                        border-radius: 50%;
                        width: 18px;
                        height: 18px;
                        cursor: pointer;
                        margin-top: 5px;
                      "
                      @click="cHash2(item)"
                    />
                    <span
                      @click="cHash2(item)"
                      style="color: #fff; cursor: pointer"
                      >{{ contractName }}</span
                    >
                  </div>
                </span>
                <el-pagination
                  :current-page.sync="PaginationIndex"
                  background
                  small
                  :page-size="size"
                  layout="prev, pager,
      next"
                  @current-change="CurrentChange1"
                  :total="totalall"
                >
                </el-pagination>
              </el-dialog>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Homeinput from "../Home/Home_input.vue";
import Homseach from "../../../components/pc/serch.vue";
import Pagination from "../BlockList/Pagination.vue";
import EmptyState from "../EmptyState/EmptyState.vue";
import {
  TransactionDetail,
  GetheightDetailBonus,
  GetheightDetailTransfer,
  ContractTransfer,
  ContractCreate,
} from "@/assets/server/api";
import {
  timestampConvertTime,
  timestampConvertTimea,
  formatSeconds,
  listTypea,
} from "@/utils/utils";
import { getSubStr } from "../../../utils/utils";
export default {
  data() {
    return {
      list: [
        {
          Total: "Block :",
          Balance: "",
          ImgUrl: "",
        },
        {
          Total: "Block Hash :",
          Balance: "",
          ImgUrl: "",
          index: 1,
        },
        {
          Total: "Transaction Hash :",
          Balance: "",
          ImgUrl: require("@/assets/pc/BkHash/BkHash1.png"),
        },
        {
          Total: "Time :",
          Balance: "",
          ImgUrl: "",
        },
        {
          Total: "Gas :",
          Balance: "",
          ImgUrl: require("@/assets/pc/BkHash/BkHash1.png"),
        },
        {
          Total: "Signed Nodes :",
          Balance: "",
          Balance1: "",
          ImgUrl: require("@/assets/pc/BkHash/BkHash1.png"),
        },
        {
          Total: "Amount :",
          Balance: "",
          ImgUrl: "",
        },
        // {
        //   Total: "Gas :",
        //   Balance: "",
        //   ImgUrl: "",
        // },
      ],
      addressLists: [],
      addressList: [],
      addressList1: [],
      copyContent: "",
      H: "",
      H2: "",
      flag: false,
      Index: "",
      INd: "",
      verifyAddressList: [],
      txHash: "",
      standard: "",
      bonusList: [],
      total: null,
      PaginationIndex: 1,
      TimeDate: [],
      TimeDatea: "",
      //开始
      activeNames: ["0"],
      activeName: 1,

      signList: [],
      Commission: "",
      validatorNickName: "",
      validatorLogo: "",
      amount: "",
      imgurl: require("@/assets/pc/Index/indexlogo.png"),
      imgurl2: require("@/assets/pc/Index/nft.png"),
      imgurl1: require("@/assets/pc/Index/vers.png"),
      toAwardList: [],
      toAwardListdata: [],
      type: "", //根据传过来的type进行展示
      //当类型为Transfer type=1
      toAddressa: [],
      toAddressaa: [],
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible3: false,
      total1: "",
      total1s: null,
      //当类型为7的时候
      contractAddress: "",
      contractCreator: "",
      contractName: "",
      //当类型为8的时候
      tokenAmount: "",
      tokenAmount1: "",
      tokenAmountlist: [],
      tokenAmountlista: [],
      tokenAmountlists: [],
      from: "",
      functions: "",
      symbol: "",
      fromAddress: "",
      fromAddress1: "",
      toAddress: "",
      toAddress1: "",
      toAddressb: "",
      logo: "",
      logo1: "",
      typename: "",
      nftImageLists: [],
      size: 10, //一页多少条
      totalall: "",
      contractTransfer: "", //  是price值
      contractTip: "", // 是reward
      // tableData: [],
    };
  },
  components: {
    Homseach,
    EmptyState,
    Pagination,
  },
  created() {},
  watch: {
    $route: {
      handler: function (to, form) {
        if (to.path === "/pc/To") {
          this.txHash = to.query.txHash;
          this.standard = to.query.standard;
          //  console.log(this.standard);
          //   console.log(this.txHash);
          this.type = to.query.type;
          //    console.log(this.type);
          // this.getTransactionDetail1();
          if (
            this.type == 99 ||
            this.type == "toAward" ||
            this.type == "commission" ||
            this.type == "fromAward"
          ) {
            this.GetDetailBonus();
          } else if (
            this.type == 1 ||
            this.type == 2 ||
            this.type == 3 ||
            this.type == 4 ||
            this.type == 5 ||
            this.type == "to" ||
            this.type == "from" ||
            this.type == -1
          ) {
            this.GetDetailTransfer();
          } else if (this.type == 7) {
            this.GetContractCreate();
          } else if (this.type == 8 && this.standard == "ERC-20") {
            this.GetContractTransfer();
            // this.GetContractCreate();
          } else if (this.type == 8 && this.standard == "ERC-721") {
            // this.GetContractCreate();
            this.GetContractTransfer();
          }
          // else if ((this.type == 7 && this.standard=='ERC-20') || (this.type==8&& this.standard=='ERC-20')) {
          //   //合约创建
          //   this.GetContractCreate();
          // //  this.GetContractTransfer();
          // } else if((this.type == 7 && this.standard=='ERC-721') || (this.type == 8 && this.standard=='ERC-721')){
          //   //合约执行
          //   //this.GetContractCreate();
          //  this.GetContractTransfer();
          // }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.H = document.documentElement.clientHeight + 1 + "px";
      this.H2 = document.documentElement.clientHeight + "px";
    });
  },
  computed: {
    getClientTimezone() {
      var oDate = new Date();
      var nTimezone = -oDate.getTimezoneOffset() / 60;
      return nTimezone.toFixed(2);
    },
    percentages() {
      // return this.toAwardList.map(item =()=> ((parseFloat(item.amount)*100).toFixed(2)));
      return this.toAwardList.reduce(
        (acc, item) => acc + parseFloat(item.amount),
        0
      );
    },
  },
  methods: {
    CurrentChange1(val) {
      //  console.log(val);
      this.PaginationIndex = val;
      this.getTabelData2();
    },
    //获取表格数据，自行分页（splice）
    getTabelData2() {
      this.tokenAmountlist = this.tokenAmountlists.slice(
        (this.PaginationIndex - 1) * this.size,
        this.PaginationIndex * this.size
      );
      this.tokenAmountlista = this.tokenAmountlists.slice(0, 5);
      //  console.log(this.tokenAmountlist);
      // this.nftImageLists =this.nftImageLists.slice((this.PaginationIndex - 1) * this.size,
      //   this.PaginationIndex * this.size)
      // th
      // let data=this.tokenAmountlists;
      // console.log(this.tokenAmountlists);
      // this.tokenAmountlist = data.splice(
      //   (this.PaginationIndex - 1) * this.size,
      //   this.size
      // );
      // this.totalall=this.tokenAmountlist.length;
      //  console.log(this.totalall);
    },
    isImageUrl(url) {
      const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "svg"]; // Add more extensions if needed
      const lowercasedUrl = url.toLowerCase();
      const extension = lowercasedUrl.split(".").pop();
      return imageExtensions.includes(extension);
    },
    check_is_img(url) {
      return (
        url.match(/\.(jpeg|jpg|gif|png|GIF|PNG|JPG|JPEG|SVG|svg)$/) != null
      );
    },
    cHash2(item) {
      //  console.log(item);
      let params = {
        contractAddress: this.contractAddress,
      };
      //   console.log(params);
      this.$router.push({ path: "/pc/NFTsdetail", query: params });
    },
    cHash(index) {
      //   console.log(index);
      // var id='#'+(index+1);
      // console.log(id);
      //  if(this.list[index].type1==8 && this.list[index].standard=='ERC-721'){
      let params = {
        contractAddress: this.contractAddress,
        tokenId: index,
      };
      //  console.log(params);
      this.$router.push({ path: "/pc/NFTslistdetail", query: params });
    },
    Address(index) {
      let params = {
        contractAddress: index,
      };
      //   console.log(params);
      this.$router.push({ path: "/pc/Overview", query: params });
    },
    handleClose() {
      this.PaginationIndex = 1;
      this.dialogVisible = false;
      this.dialogVisible1 = false;
      this.dialogVisible3 = false;
      // this.GetDetailTransfer();
    },
    handleChange(val) {
      //    console.log(val);
    },
    //合约执行(type==8)
    async GetContractTransfer() {
      this.txHash = this.$route.query.txHash;
      let formData = new FormData();
      let params = {
        txHash: this.txHash,
      };
      let item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      var res = await ContractTransfer(formData);
      //    console.log(res);

      let UTCTime = res.result.tradeTime - this.getClientTimezone * 3600000;
      this.TimeDate = timestampConvertTime(UTCTime);
      var calctime = new Date();
      let strdate = Math.floor(calctime.getTime() / 1000);
      let timestamp = Math.floor(res.result.tradeTime) / 1000;
      var s = strdate - timestamp;
      if (s <= 0) {
        s = 1;
      }
      //     console.log(s);
      this.list[4].Balance = formatSeconds(s);
      this.list[0].Balance = res.result.height;
      this.list[1].Balance = res.result.blockHash;
      this.list[2].Balance = res.result.txHash;
      //  this.list[3].Balance=res.result.blockHash;
      this.list[5].Balance = res.result.gas;
      this.signList = res.result.signNodes;
      //  console.log(this.signList);
      this.from = res.result.from;
      this.functions = res.result.functions;
      this.fromAddress = res.result.fromEvmAddress;
      this.fromAddress1 = getSubStr(this.fromAddress, 0, 6);
      this.contractAddress = res.result.contractAddress;
      this.toAddress = res.result.toEvmAddress;
      this.contractTransfer = res.result.contractTransfer;
      // console.log(this.contractTransfer);
      this.contractTip = res.result.contractTip;
      //    console.log(this.toAddress);

      if (
        res.result.toEvmAddress == null ||
        res.result.toEvmAddress == "" ||
        this.toAddress == ""
      ) {
        //  console.log(this.toAddress);
        this.toAddress1 = this.toAddress;
        // console.log(this.toAddress1);
        // this.toAddress1 = getSubStr(this.toAddress, 0, 6);
      } else {
        this.toAddress = res.result.toEvmAddress;
        //  console.log(this.toAddress);
        this.toAddress1 = this.toAddress;
        this.toAddress1 = getSubStr(this.toAddress, 0, 6);
      }
      if (res.result.functions == "balanceOf") {
        this.toAddress1 = "";
      }
      if (
        res.result.logo == "" ||
        res.result.logo == null ||
        this.check_is_img(res.result.logo) == false
      ) {
        if (res.result.functions == "mint") {
          this.logo = this.imgurl2;
        } else {
          this.logo = this.imgurl;
        }
      } else {
        this.logo = res.result.logo;
      }

      // if(res.result.toAddress !==''){
      //   this.toAddress1 = getSubStr(res.result.toAddress, 0, 6);
      // }

      this.symbol = res.result.symbol;
      if (res.result.tokenAmount !== null || res.result.tokenAmount != "") {
        this.tokenAmount = res.result.tokenAmount;
        // this.tokenAmount1=(this.tokenAmount).split('#')[1];
        // console.log(this.tokenAmount1);
      }

      //  console.log(((this.tokenAmount1).split('#')[0]))
      if (this.tokenAmount !== null) {
        this.tokenAmountlist = res.result.tokenAmount.split(",");
        this.tokenAmountlista = res.result.tokenAmount.split(",");
        this.tokenAmountlista = this.tokenAmountlista.slice(0, 5);
        this.tokenAmountlists = res.result.tokenAmount.split(",");
        // console.log(this.tokenAmountlist);
        this.totalall = this.tokenAmountlist.length;
        //     console.log(this.totalall);
        this.tokenAmount = this.tokenAmountlist[0];
      }
      // console.log(this.tokenAmountlist);
      // console.log(this.tokenAmountlist.length);
      this.contractName = res.result.contractName;
      //  console.log(this.contractName);
      if (res.result.nftNameList !== "" && res.result.standard == "ER-721") {
        this.contractName = JSON.parse(res.result.nftNameList)[0];
      }
      if (
        res.result.logo == "" ||
        res.result.logo == null ||
        this.check_is_img(res.result.logo) == false
      ) {
        this.logo1 = this.imgurl;
        //  console.log(444);
      } else {
        this.logo1 = res.result.logo;
        ///  console.log(555);
      }
      if (
        res.result.logo == "" ||
        res.result.logo == null ||
        this.check_is_img(res.result.logo) == false
      ) {
        this.logo = this.imgurl2;
        // console.log(2222);
      } else {
        if (res.result.nftImageList !== null) {
          var images = JSON.parse(res.result.nftImageList);
          //    console.log(images);
          if (images.length == 1) {
            this.logo = images[0];
            this.logo = this.isImageUrl(images[0]);
            // if (this.check_is_img(this.logo) == false) {
            //   this.logo = this.imgurl2;
            // }
            if (this.logo == false) {
              this.logo = this.imgurl2;
            }
          }
          // this.isImage = this.isImageUrl(this.tokenList[i].logo);
          // console.log(this.isImage);
          // if (this.isImage == false) {
          //   this.tokenList[i].logo = this.imgurl;
          // } else {
          //   this.tokenList[i].logo = this.tokenList[i].logo;
          // }
          // nftImageLists
          if (images.length > 1) {
            this.nftImageLists = JSON.parse(res.result.nftImageList);
            //  console.log(this.nftImageLists);
          }
        } else {
          this.logo = res.result.logo;
          if (this.logo == "") {
            this.logo = this.imgurl2;
          }
        }
        // this.logo = res.result.logo;
      }
      if (res.result.standard == "ERC-20" && res.result.logo == "") {
        this.logo = this.imgurl;
      }
      if (res.result.standard !== "ERC-20" && res.result.logo == "") {
        this.logo = this.imgurl2;
      }
      if (res.result.type == "8" && res.result.standard == "ERC-721") {
        var images = JSON.parse(res.result.nftImageList);
        if (res.result.nftImageList !== null) {
          var images = JSON.parse(res.result.nftImageList);
          //  console.log(images);
          if (images.length == 1) {
            this.logo = images[0];
            // if (this.check_is_img(this.logo) == false) {
            //   this.logo = this.imgurl2;
            // }
          }
          // nftImageLists
          if (images.length > 1) {
            this.nftImageLists = JSON.parse(res.result.nftImageList);
            //     console.log(this.nftImageLists);
          }
        } else {
          this.logo = this.imgurl2;
          // if (this.logo == "" || this.check_is_img(this.logo) == false) {
          //   this.logo = this.imgurl2;
          // }
        }
      }
      if (
        res.result.type == "8" &&
        res.result.standard == "ERC-20" &&
        (res.result.logo == null || res.result.logo == "")
      ) {
        //this.logo = res.result.logo;
        this.logo = this.imgurl;
      }
      //判断8 standard ERC 721 functions mint
      if (
        res.result.type == "8" &&
        res.result.standard == "ERC-721" &&
        res.result.functions == "mint"
      ) {
        if (res.result.logo == null) {
          //console.log(1111);
          this.logo1 = this.imgurl;
        }
      }
    },
    //合约创建(type==7)
    async GetContractCreate() {
      this.txHash = this.$route.query.txHash;
      let formData = new FormData();
      let params = {
        txHash: this.txHash,
      };
      let item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      var res = await ContractCreate(formData);
      //   console.log(res);
      let UTCTime = res.result.tradeTime - this.getClientTimezone * 3600000;
      this.TimeDate = timestampConvertTime(UTCTime);
      var calctime = new Date();
      let strdate = Math.floor(calctime.getTime() / 1000);
      let timestamp = Math.floor(this.gltime(res.result.tradeTime) / 1000);
      var s = strdate - timestamp;
      if (s <= 0) {
        s = 1;
      }
      //    console.log(s);
      this.list[4].Balance = formatSeconds(s);
      this.list[0].Balance = res.result.height;
      this.list[1].Balance = res.result.blockHash;
      this.list[2].Balance = res.result.txHash;
      //  this.list[3].Balance=res.result.blockHash;
      this.list[5].Balance = res.result.gas;
      this.signList = res.result.signNodes;
      // contractAddress:"",
      // contractCreator:"",
      // contractName:"",
      this.contractAddress = res.result.contractAddress;
      this.contractCreator = res.result.contractCreator;
      this.contractName = res.result.contractName;
      //  console.log(this.contractName);
      if (this.contractName == "" || this.contractName == null) {
        if (res.result.symbol == "" || res.result.symbol == null) {
          //  console.log(333);

          this.contractName = getSubStr(this.contractAddress, 0, 3);
          //  this.contractName=getSubStr(this.contractAddress,0,3);
        } else {
          this.contractName = res.result.symbol;
        }
      }
    },
    async GetDetailTransfer() {
      this.txHash = this.$route.query.txHash;
      let formData = new FormData();
      let params = {
        txHash: this.txHash,
        pageNum: this.PaginationIndex,
        pageSize: 5,
      };
      // console.log(this.PaginationIndex);
      let item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      var res = await GetheightDetailTransfer(formData);
      //    console.log(res);
      this.typename = listTypea(res.result.type);

      this.list[0].Balance = res.result.height;
      this.list[1].Balance = res.result.blockHash;
      //    console.log(this.list[1].Balance);
      this.list[2].Balance = res.result.txHash;
      //    console.log(this.list[2].Balance);
      //    console.log(res.result.tradeTime);
      let UTCTime = res.result.tradeTime - this.getClientTimezone * 3600000;

      // console(UTCTime);
      this.TimeDate = timestampConvertTime(UTCTime);
      this.TimeDatea = timestampConvertTimea(UTCTime);
      var calctime = new Date();
      let strdate = Math.floor(calctime.getTime() / 1000);
      let timestamp = Math.floor(this.gltime(res.result.tradeTime) / 1000);

      var s = strdate - timestamp;
      if (s <= 0) {
        s = 1;
      }
      // this.list[3].Balance = 11111;
      this.list[4].Balance = formatSeconds(s);
      this.list[5].Balance = res.result.gas;
      this.signList = res.result.signNodes;
      this.fromAddress = res.result.fromAddress;
      if (this.fromAddress == "Unpledge") {
        this.fromAddress = "Unstake";
      }
      if (this.PaginationIndex == 1 && res.result.toList.length > 0) {
        this.toAddressaa = res.result.toList;
        //console.log(this.toAddressaa);
      }
      this.toAddressa = res.result.toList;
      //     console.log(this.toAddressa);
      if (this.toAddressa.length == 0) {
        this.toAddressb = res.result.toAddress;
        //    console.log(this.toAddressb);
        if (this.toAddressb == "Pledge") {
          this.toAddressb = "Stake";
        }
      }
      //     console.log(this.toAddressa);
      this.total1s = res.result.toCount;
      //console.log(this.total1s);
      this.amount = res.result.amount;
    },
    async GetDetailBonus() {
      this.txHash = this.$route.query.txHash;
      let formData = new FormData();
      let params = {
        txHash: this.txHash,
      };
      let item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      var res = await GetheightDetailBonus(formData);
      //    console.log(res);
      this.signList = res.result.signList;
      this.amount = res.result.amount;
      this.total1s = res.result.toAwardList.length;
      this.Commission = res.result.Commission;
      if (res.result.validatorNickName == "") {
        this.validatorNickName = getSubStr(res.result.validatorAddress, 0, 6);
      } else {
        this.validatorNickName = res.result.validatorNickName;
      }
      // this.fromAddress=res.result.fromAddress;
      //      console.log(this.fromAddress);
      this.validatorLogo = res.result.validatorLogo;
      this.toAwardList = res.result.toAwardList;
      //     console.log(this.toAwardList);
      if (this.validatorLogo == "") {
        this.validatorLogo = this.imgurl1;
      }
      // for(var i=0;i<this.toAwardList.length;i++){
      //   if(parseFloat(this.toAwardList[i].amount)<parseFloat(0.01)){
      //     this.toAwardList[i].amount=0.01;
      //   }
      // }

      //    console.log(this.signList);
      this.list[0].Balance = res.result.height;
      this.list[1].Balance = res.result.blockHash;
      //     console.log(this.list[1].Balance);
      this.list[2].Balance = res.result.txHash;
      //     console.log(this.list[2].Balance);
      let UTCTime = res.result.tradeTime - this.getClientTimezone * 3600000;
      this.TimeDate = timestampConvertTime(UTCTime);
      this.TimeDatea = timestampConvertTimea(UTCTime);
      //    console.log(this.TimeDatea);
      //     console.log(this.TimeDatea.split(",")[1] - 1);
      this.TimeDatea =
        this.TimeDatea.split(",")[0] +
        "," +
        (this.TimeDatea.split(",")[1] - 1) +
        "," +
        this.TimeDatea.split(",")[2];
      var calctime = new Date();
      let strdate = Math.floor(calctime.getTime() / 1000);
      let timestamp = Math.floor(this.gltime(res.result.tradeTime) / 1000);
      var s = strdate - timestamp;
      if (s <= 0) {
        s = 1;
      }

      this.list[4].Balance = formatSeconds(s);
      this.list[5].Balance = res.result.gas;
    },

    async transactionDetail() {
      const params = {
        pageNum: this.PaginationIndex,
        pageSize: 10,
        txHash: this.txHash,
      };
      const formData = new FormData();
      const item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      await TransactionDetail(formData).then((res) => {
        this.total = res.result.toCount;
        this.bonusList = res.result.toList;
        this.verifyAddressList = res.result.verifyAddressList;
      });
    },
    gltime(i) {
      const toDate = new Date(i);
      var d = toDate;
      var localTime = d.getTime();
      var localOffset = d.getTimezoneOffset() * 60000;
      var utc = localTime + localOffset;
      var offset = this.getClientTimezone;
      var korean = utc + 3600000 * offset;
      var nd = korean;
      return nd;
    },

    More() {
      this.flag = true;
      this.stopMove();
    },
    none() {
      this.flag = false;
      sessionStorage.removeItem("tiaozhuan");
      this.Move();
    },
    form() {
      this.$router.push({
        path: "/pc/BkHash",
        query: { query: this.$refs.ele1.innerText.trim() },
      });
    },
    address(index) {
      this.$router.push({
        path: "/pc/BkHash",
        query: { query: this.signList[index] },
      });
      //  this.$router.push({ path: "/pc/BkDetail", query: { blockHash: index } });
    },
    Hash(index) {
      //      console.log(index);
      this.$router.push({ path: "/pc/BkDetail", query: { blockHash: index } });
    },
    to() {
      this.$router.push({
        path: "/pc/BkHash",
        query: { query: this.$refs.ele2.innerText.trim() },
      });
    },
    Block(index) {
      let params = {
        contractAddress: index,
      };
      this.$router.push({
        path: "/pc/Overview",
        query: params,
      });
    },
    from2(item) {
      this.$router.push({
        path: "/pc/BkHash",
        query: { query: item },
      });
    },
    to2(item) {
      this.$router.push({
        path: "/pc/BkHash",
        query: { query: item },
      });
    },
    MoreTo(index) {
      this.Move();
      this.$router.push({
        path: "/pc/BkHash",
        query: { query: this.$refs.eles[index].innerText.trim() },
      });
    },
    blockHeight(index) {
      this.$router.push({ path: "/pc/BkHeight", query: { height: index } });
    },
    Fuz() {
      this.copyContent = this.$refs.ele.innerText.trim();
    },

    onCopy(e) {
      this.$message({
        message: "Copy successful",
        type: "success",
        center: true,
        duration: "500",
      });
    },
    onError(e) {
      this.$message.error("copy failed");
    },
    searchs(e) {
      this.txHash = e.txHash;
      this.transactionDetail();
    },
    stopMove() {
      document.body.style.overflow = "hidden";
      document.body.style.paddingRight = "17px";
    },
    Move() {
      document.body.style.overflow = "";
      document.body.style.paddingRight = "0px";
    },
    CurrentChange(val) {
      this.PaginationIndex = val;
      this.GetDetailTransfer();
      //this.GetDetailBonus();
    },
    setContextData: function (key, value) {
      if (typeof value == "string") {
        sessionStorage.setItem(key, value);
      } else {
        sessionStorage.setItem(key, JSON.stringify(value));
      }
    },
    getContextData: function (key) {
      const str = sessionStorage.getItem(key);
      if (typeof str == "string") {
        try {
          return JSON.parse(str);
        } catch (e) {
          return str;
        }
      }
      return;
    },
  },
};
</script>

<style lang="less" scoped>
.listbox {
  display: block;
}
.listbox::-webkit-scrollbar {
  display: none;
}
/deep/ .saveAsDialog {
  width: 520px !important;
}

/* 垂直滚动条样式 */
/* 宽度 */
::-webkit-scrollbar {
  width: 12px;
}
/* 背景色 */
::-webkit-scrollbar-track {
  background-color: #000000;
}
/* 滑块颜色 */
::-webkit-scrollbar-thumb {
  background-color: #000000;
}

/* 水平滚动条样式 */
/* 高度 */
::-webkit-scrollbar {
  height: 12px;
}
/* 背景色 */
::-webkit-scrollbar-track {
  background-color: #000000;
}
/* 滑块颜色 */
::-webkit-scrollbar-thumb {
  background-color: #000000;
}
// .el-collapse {
//   background: red !important;
// }
// .el-collapse-item {
//   background: red !important;
// }

/deep/.el-collapse-item__wrap {
  background: #0b0c0f !important;
  border: none !important;
}
/deep/.el-collapse-item__header {
  background: #0b0c0f !important;
  border: none !important;
  color: #fff !important;
  margin-top: -16px;
}
/deep/.el-collapse {
  border: none !important;
}
/deep/.el-collapse-item__arrow {
  display: none;
}
/deep/.el-dialog__title {
  margin-left: 80px;
  font-size: 14px;
  font-family: Poppins-Medium, Poppins;
  font-weight: 500;
  color: #898b8d;
}
.v-modal {
  opacity: 0.8 !important;
  background: #13161b !important;
}
/deep/.el-dialog {
  width: 520px;
}
/deep/.el-dialog {
  // border: 1px solid red;
//  background: rgba(0, 0, 0, 0.8);
  width: 520px !important;
  height: 385px !important;
  background:#13161B;
  border-radius: 20px 20px 20px 20px;
  margin-top: 230px !important;
  left: 20px !important;
}
/deep/.el-dialog__body {
  padding: 0 !important;
}
/deep/.el-button--text {
  color: #fff !important;
  cursor: pointer;
  margin-top: -10px;
}
/deep/.el-dialog__header {
  padding-bottom: 0px !important;
}
</style>
<style lang="less" scoped>
.BkHash {
  width: 100%;
  background: #13161b;
  .BkHash-W {
    width: 1160px;
    margin: 0 auto;
    background: #13161b;
    .BkHash-Inp {
      padding: 40px 0;
    }
    .BkHash_conent {
      background: #0b0c0f;
      border-radius: 16px 16px 16px 16px;
      padding: 20px 20px;
      // margin-bottom: 20px;
      .BkHash_conent_header {
        p {
          span:nth-child(1) {
            font-size: 18px;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: 500;
            color: #ffffff;
            line-height: 24px;
            -webkit-background-clip: text;
          }
        }
      }
      .BkHash_conent_Ul {
        ul {
          .listbox {
            // color: rgba(255, 255, 255, 0.9);
            // color: red;
            display: flex;
            flex-wrap: wrap;
            margin-top: 10px;
            .listboxli {
              width: 160px;
              color: #fff;
              cursor: pointer;
              padding-right: 30px;
              font-size: 12px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              overflow: hidden; /*内容会被修剪，并且其余内容是不可见的*/
              text-overflow: ellipsis; /*显示省略符号来代表被修剪的文本。*/
              white-space: nowrap; /*文本不换行*/
            }
            .listboxli:hover {
              color: #00a870;
              cursor: pointer;
            }
          }
          li {
            display: flex;
            // height: 62px;
            p:nth-child(1) {
              flex: 0 0 11%;
              font-size: 14px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #898b8d;
              line-height: 62px;
              -webkit-background-clip: text;
              margin-right: 169px;
            }
            p:nth-child(2) {
              flex: 0 0 60%;
              font-size: 14px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              line-height: 62px;
              -webkit-background-clip: text;
              .blocks {
                color: #fff;
                cursor: pointer;
              }
            }

            .divs {
              flex: 0 0 60%;
              font-size: 14px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: rgba(255, 255, 255, 0.9);
              // line-height: 62px;
              -webkit-background-clip: text;
              .divss {
                // display: flex;
                margin-top: 18px;
              }
              .active {
                color: #00a870;
                cursor: pointer;
              }
            }
            img {
              cursor: pointer;
              margin-left: 20px;
            }
          }

          .Height1 {
            //  height: 104px;
          }
          li:nth-child(1) {
            p:nth-child(2) {
              span {
                // color: #00a870;
                // color: red;
                font-size: 14px;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                color: #ffffff;
                cursor: pointer;
              }
              span:hover {
                color: #00a870;
              }
            }
          }
          li:nth-child(2) {
            color: #898b8d;
            img {
              width: 24px;
              height: 24px;
              margin-top: 18px;
            }
          }
          li:nth-child(3),
          li:nth-child(4),
          li:nth-child(5) {
            color: #898b8d;
            font-size: 14px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
          }
          li:nth-child(5) {
            p:nth-child(2) {
              color: #898b8d;
              cursor: pointer;
              .bukdian {
                color: rgba(255, 255, 255, 0.9) !important;
              }
            }
            img {
              width: 24px;
              height: 24px;
              margin-top: 18px;
            }
          }
          li:nth-child(6) {
            p:nth-child(2) {
              line-height: 0;
              margin-top: 22px;
              color: #fff;
              .listbox {
                // color: rgba(255, 255, 255, 0.9);
                // color: red;
                display: flex;
                flex-wrap: wrap;
                margin-top: 10px;
                .listboxli {
                  width: 160px;
                  color: #fff;
                  cursor: pointer;
                  padding-right: 30px;
                  font-size: 12px;
                  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                  font-weight: 400;
                  overflow: hidden; /*内容会被修剪，并且其余内容是不可见的*/
                  text-overflow: ellipsis; /*显示省略符号来代表被修剪的文本。*/
                  white-space: nowrap; /*文本不换行*/
                }
                .listboxli:hover {
                  color: #00a870;
                  cursor: pointer;
                }
              }
              span:nth-child(1) {
                line-height: 22px;
              }
            }
            img {
              width: 24px;
              height: 24px;
              // margin-top: 18px;
            }
            .xiegang {
              line-height: 62px !important;
            }
          }
          li:nth-child(6) {
            // margin-top: 20px;
          }
        }
      }
    }
  }
}
.el-pagination {
  display: flex;
  justify-content: right;
  ::v-deep button {
    min-width: 24px !important;
    height: 24px !important;
    font-size: 12px;
    color: #fff !important;
    background: none !important;
    // background: #3c485c !important;
    border-radius: 4px 4px 4px 4px !important;
  }
  ::v-deep ul {
    li {
      min-width: 24px !important;
      height: 24px !important;
      background: none !important;
      //border-radius: 4px 4px 4px 4px !important;
      font-size: 12px;
      font-family: aaa;
      font-weight: 400 !important;
      color: #ffffff !important;
      line-height: 20px !important;
      margin: 0 4px !important;
      padding: 2px 8px !important;
    }
    .active {
      background: #22252e !important;
    }
    .more::before {
      line-height: 20px !important;
    }
  }
}
.Signed {
  background: #232a35;
  border-radius: 16px 16px 16px 16px;
  padding: 20px 20px;
  .Signed_top {
    position: relative;
    span:nth-child(1) {
      display: inline-block;
      font-size: 16px;
      font-family: SF Pro Text-Medium, SF Pro Text;
      font-weight: 500;
      color: rgba(255, 255, 255, 0.9);
      line-height: 24px;
      -webkit-background-clip: text;
      padding: 0 20px;
      margin-bottom: 24px;
    }
    span:nth-child(2) {
      width: 50%;
      display: inline-block;
      position: absolute;
      right: 0;
    }
  }
  .Signed_Ul {
    li {
      display: flex;
      height: 62px;
      background: #2c3645;
      p:nth-child(1) {
        width: 167px;
        margin-left: 20px;
        margin-right: 187px;
        // flex: 0 0 39%;
        font-size: 14px;
        font-family: SF Pro Text-Medium, SF Pro Text;
        font-weight: 500;
        color: #ffffff;
        line-height: 62px;
        -webkit-background-clip: text;
        text-align: center;
      }
      p:nth-child(2) {
        font-size: 14px;
        font-family: SF Pro Text-Medium, SF Pro Text;
        font-weight: 500;
        color: #ffffff;
        line-height: 62px;
        -webkit-background-clip: text;
      }
    }
  }
  .Signed_Ul1 {
    li {
      display: flex;
      height: 62px;
      border-bottom: 1px solid #3c485c;
      p:nth-child(1) {
        width: 167px;
        margin-left: 20px;
        margin-right: 187px;
        font-size: 14px;
        font-family: SF Pro Text-Medium, SF Pro Text;
        font-weight: 500;
        color: #ffffff;
        line-height: 62px;
        -webkit-background-clip: text;
        text-align: center;
      }
      p:nth-child(2) {
        font-size: 14px;
        font-family: SF Pro Text-Medium, SF Pro Text;
        font-weight: 500;
        color: #ffffff;
        line-height: 62px;
        -webkit-background-clip: text;
      }
    }
    li:nth-child(11) {
      border-bottom: none;
    }
  }
  .Block_List_Bottom:nth-child(4) {
    margin-top: 20px;
    padding-bottom: 20px;
  }
}

.BkHash_conentb {
  background: #0b0c0f;
  border-radius: 16px 16px 16px 16px;
  padding: 20px 20px;
  margin-top: 20px;
  // margin-bottom: 20px;
  .BkHash_conent_header {
    p {
      span:nth-child(1) {
        font-size: 18px;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #ffffff;
        line-height: 24px;
        -webkit-background-clip: text;
      }
    }
  }
  .BkHash_conent_Ul {
    margin-top: 20px;
    ul {
      li {
        display: flex;
        // height: 62px;
        p:nth-child(1) {
          flex: 0 0 13%;
          font-size: 14px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #898b8d;
          line-height: 40px;
          -webkit-background-clip: text;
          margin-right: 120px;
        }
        p:nth-child(2) {
          flex: 0 0 60%;
          font-size: 14px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          line-height: 40px;
          -webkit-background-clip: text;
          .blocks {
            color: #fff;
            cursor: pointer;
          }
        }
        .activnams {
          // height: 100px;
          /deep/.el-collapse-item__header {
            height: 0 !important;
          }
          .el-collapse-item__wrap {
            margin-top: -10px;
          }
        }
        .divs {
          flex: 0 0 60%;
          font-size: 14px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.9);
          // line-height: 62px;
          -webkit-background-clip: text;
          .divss {
            // display: flex;
            margin-top: 18px;
          }
        }
        img {
          height: 24px;
          margin-top: 6px;
        }
      }
      li:nth-child(4) {
        p:nth-child(2) {
          line-height: 0;
          margin-top: 12px;
          color: #fff;
          .listbox {
            // color: rgba(255, 255, 255, 0.9);
            // color: red;
            display: flex;
            flex-wrap: wrap;
            margin-top: 10px;
            img {
              // width: 24px;
              height: 24px;
              // margin-top: -2px;
              margin-left: 6px;
              margin-right: 6px;
              // margin-top: 18px;
            }
            .black {
              color: #fff;
              cursor: pointer;
            }
          }
          span:nth-child(1) {
            line-height: 22px;
            color: #898b8d;
          }
        }
        img {
          height: 24px;
          // margin-top: 18px;
        }
        .xiegang {
          line-height: 62px !important;
        }
      }
    }
  }
}
.mianb {
  height: 423px;
}
.mianaa {
  height: 520px !important;
  .tangkuang {
    //  border: 1px solid red;
    width: 397px;
    margin: 0 auto;
    .tangkuang_tit {
      display: flex;
      justify-content: space-between;
      height: 38px;
      div {
        height: 26px;
        font-size: 18px;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #ffffff;
        line-height: 26px;
      }
    }

    .tangkuang_con {
      height: 295px;
      overflow: hidden;
      overflow-y: auto;
      .tangkuang_li {
        display: flex;
        height: 40px;
        padding-top: 18px;
        img {
          width: 22px;
          height: 22px;
          margin-left: 42px;
          // margin-right: 12px;
        }
        span {
          font-size: 14px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #ffffff;
        }
        span:nth-child(1) {
          width: 200px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          -o-text-overflow: ellipsis;
        }
        span:nth-child(3) {
          width: 240px;
          text-align: right;
          color: #898b8d;
        }
      }
    }
    .tangkuang_con::-webkit-scrollbar {
      display: none;
    }
  }
}
.miana,
.mianaa,
.mianb {
  .overview_flex {
    display: flex;
    height: 20px;
    line-height: 20px;
    margin-bottom: 20px;
    .overview_flexl {
      margin-top: 10px;
      .overview_flexlc {
        display: flex;
        span {
          margin-top: 12px;
        }
        .black {
          color: #fff;
          cursor: pointer;
        }
        .black:hover {
          color: #00a870;
          cursor: pointer;
        }
      }
      font-size: 14px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
    }
    .overview_flexr {
      margin-top: 10px;
      .overview_flexlc {
        display: flex;
        span {
          margin-top: 12px;
        }
        .black {
          color: #fff;
        }
        .black:hover {
          color: #00a870;
          cursor: pointer;
        }
      }
      margin-left: 48px;
      font-size: 14px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #898b8d;
    }
  }
}
.mianb {
  height: 339px;

  .contract {
    display: flex;
    font-size: 14px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    span {
      font-size: 14px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #898b8d;
      margin-right: 5px;
    }
    img {
      width: 19px;
      height: 21px;
      margin-top: 10px;
      margin-left: 20px;
    }
    .hash {
      margin-left: 10px;
      cursor: pointer;
    }
  }
  img {
    width: 19px;
    height: 21px;
    margin-top: 10px;
  }
}
.overmore {
  width: 1160px;
  margin-top: 20px;
  background: #0b0c0f;
  opacity: 1;
  border-radius: 12px;
  padding-bottom: 30px;
  .overmore_tit {
    padding-top: 30px;
    margin-left: 40px;
    font-size: 18px;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    color: #ffffff;
  }
  .overmore_con {
    display: flex;
    flex-direction: column;
    margin-left: 40px;

    // margin-top: 20px;
    .overmore_li {
      margin-top: 20px;
      // height: 60px;
      // line-height: 60px;
      display: flex;
      .overmore-lil {
        width: 174px;
        margin-right: 160px;
        font-size: 14px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #898b8d;
        // margin-top: 10px;
      }
      .overmore-lir {
        div:nth-child(1) {
          color: #fff;
          cursor: pointer;
          font-size: 14px;
        }
      }
      .block {
        color: #fff !important;
        cursor: pointer;
        font-size: 14px;
      }
      .overmore-lir {
        color: #898b8d;
        font-size: 14px;
        // border: 1px solid red;
        .overmore_adressbox {
          div {
            margin: 0px;
            padding-top: 0px;
            padding-bottom: 16px;
            font-size: 14px;
            img {
              width: 20px;
              height: 20px;
              margin-left: 12px;
              margin-right: 12px;
            }
          }
          // padding-bottom: 20px;
        }
      }
    }
    .tangkuang {
      //  border: 1px solid red;
      width: 397px;
      margin: 0 auto;
      .tangkuang_tit {
        display: flex;
        justify-content: space-between;
        height: 38px;
        div {
          height: 26px;
          font-size: 18px;
          font-family: Source Han Sans CN-Medium, Source Han Sans CN;
          font-weight: 500;
          color: #ffffff;
          line-height: 26px;
        }
      }
      .tangkuang_con {
        height: 240px;
        overflow: hidden;
        .tangkuang_li {
          display: flex;
          height: 40px;
          padding-top: 18px;
          img {
            width: 22px;
            height: 22px;
            margin-left: 42px;
            // margin-right: 12px;
          }
          span {
            font-size: 14px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #ffffff;
          }
          span:nth-child(1) {
            width: 200px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;
          }
          span:nth-child(3) {
            width: 120px;
            text-align: right;
          }
        }
      }
    }
  }
}
.Overviewb {
  width: 1160px;
  margin-top: 20px;
  background: #0b0c0f;
  opacity: 1;
  border-radius: 12px;
  padding-bottom: 30px;
  .overview_title {
    padding-top: 30px;
    margin-left: 40px;
    font-size: 18px;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    color: #ffffff;
  }
  .overview_content {
    display: flex;
    margin-left: 40px;
    margin-top: 37px;
    .overview_left {
      font-size: 14px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #898b8d;
    }
    .overview_right {
      font-size: 14px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #898b8d;
      margin-left: 213px;
      // .contract{
      //   display: flex;
      // }
      img {
        width: 24px;
        height: 24px;
        margin-top: 10px;
        margin-right: 4px;
        margin-left: 0px;
      }
      .toadress {
        color: #fff;
        font-size: 14px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        .toadress_box {
          // border: 1px solid red;

          // div {
          //   height: 30px;
          // }
        }
      }
    }
  }
}
.Overview {
  width: 1160px;
  margin-top: 20px;
  min-height: 393px;
  background: #0b0c0f;
  opacity: 1;
  border-radius: 12px;
  padding-bottom: 30px;
  .overview_title {
    padding-top: 30px;
    margin-left: 40px;
    font-size: 18px;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    color: #ffffff;
  }
  .overview_content {
    display: flex;
    margin-left: 40px;
    margin-top: 37px;
    .overview_left {
      font-size: 14px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #898b8d;
      height: 45px;
      line-height: 45px;
    }
    .overview_right {
      font-size: 14px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #898b8d;
      height: 45px;
      line-height: 45px;
      margin-left: 213px;
      img {
        width: 24px;
        height: 24px;
        margin-top: 10px;
        margin-right: 4px;
        margin-left: 0px;
      }
      .toadress {
        color: #fff;
        font-size: 14px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        .toadress_box {
          //    border: 1px solid red;

          div {
            height: 30px;
          }
        }
      }
    }
  }
}
</style>
